import { NgModule } from '@angular/core';
import { HelpManualOpenDirective } from './help-manual-open.directive';

@NgModule({
  declarations: [HelpManualOpenDirective],
  imports: [],
  exports: [HelpManualOpenDirective],
})
export class HelpManualOpenModule {}
